import Footer from '../../Footer/Footer';
import Navbar from '../../Navbar/Navbar';

import 'aos/dist/aos.css';
import AOS from 'aos';
import impactresistant from '../../../images/ImpactResistant.jpg';
import favicon from '../../../images/logo2.png'
import { Helmet } from 'react-helmet';



import { useEffect } from 'react';

const FireResistant: React.FC = () => {

  useEffect(() => {
    AOS.init();
  }, []);


  return (
    <>

      <Helmet>
        
        <title>Impact Resistant Gypsum Board Manufacturer & Supplier in Mumbai </title>

        <meta name="description" content="White Panther Gypsum supplies premium impact resistant gypsum boards in Mumbai, ideal for durable, high-strength walls and ceiling systems across Maharashtra." />

        <meta name="keywords" content="impact resistant gypsum board, gypsum board manufacturers Mumbai, impact resistant drywall India, heavy-duty gypsum board suppliers Maharashtra, White Panther Gypsum, strong gypsum boards, high strength gypsum panels, impact proof wall boards, gypsum wallboard suppliers India, commercial gypsum boards Mumbai" />

        <link rel="icon" href={favicon} type="image/png" />

        <meta property="og:title" content="Moisture & Mold-Resistant Gypsum Board Suppliers in Mumbai - White Panther Gypsum" />
        <meta property="og:description" content="Get high-quality moisture and mold-resistant gypsum boards from White Panther Gypsum in Mumbai. Ideal for wet areas and high-humidity environments, our non-paper-faced, glass mat-reinforced boards ensure superior performance." />
        <meta property="og:image" content="http://www.whitepanthergypsum.com/static/media/paperlesssheet.b11b522774d2d6cc43d7.png" />
        <meta property="og:url" content="https://www.whitepanthergypsum.com/Paperless" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Moisture & Mold-Resistant Gypsum Board Suppliers in Mumbai - White Panther Gypsum" />
        <meta name="twitter:description" content="Looking for moisture and mold-resistant gypsum boards? White Panther Gypsum manufactures & supplies premium-quality gypsum boards for wet and high-humidity areas in Mumbai." />
        <meta name="twitter:image" content="https://www.whitepanthergypsum.com/Paperless/gypsum-board.jpg" />

        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "White Panther Gypsum - Moisture & Mold-Resistant Gypsum Board Manufacturers",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "XYZ Road",
          "addressLocality": "Mumbai",
          "addressRegion": "MH",
          "postalCode": "400001",
          "addressCountry": "IN"
        },
        "telephone": "+91-XXXXXXXXXX",
        "url": "https://www.whitepanthergypsum.com/Paperless",
        "sameAs": [
          "https://facebook.com/whitepanthergypsum",
          "https://linkedin.com/company/whitepanthergypsum"
        ]
      }
    `}
        </script>
      </Helmet>
      <Navbar></Navbar>

      <div className="relative flex flex-col-reverse py-16 lg:py-0 lg:flex-col m-10" data-aos="fade-right"
        data-aos-offset="600"
        data-aos-easing="ease-in-sine">
        <div className="w-full max-w-xl px-4 mx-auto md:px-0 lg:px-8 lg:py-20 lg:max-w-screen-xl">
          <div className="mb-0 lg:max-w-lg lg:pr-8 xl:pr-6">
            <h1 className="bg-gradient-to-r from-purple-600 to-pink-500 text-transparent bg-clip-text font-bold text-center text-3xl sm:text-4xl md:text-5xl uppercase">
              WP-Gypsum
              <br className="hidden md:block" />
               Impact Resistant Board
            </h1>
            <p className="mb-5 text-base text-gray-700 font-semibold sm:text-lg md:text-2xl text-justify pt-4">
            The WP Gypsum Impact Resistant Board is a high-performance gypsum board engineered to withstand heavy impact and surface damage in high-traffic areas. Designed with a reinforced core and durable paper facings, it offers superior strength, durability, and sound insulation compared to standard gypsum boards.
            </p>
            <div className="flex flex-col md:flex-row items-center justify-center md:items-start">
              <a href="https://wa.me/919819600149" className="inline-flex items-center justify-center h-12 px-6 mb-4 md:mr-6 md:mb-0 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-gradient-to-r from-cyan-500 to-blue-500 focus:shadow-outline focus:outline-none hover:text-white">
                Get Quote
              </a>
            </div>
          </div>
        </div>
        <div className="inset-y-0 top-0 right-0 w-full max-w-xl px-4 mx-auto mb-6 md:px-0 lg:pl-8 lg:pr-0 lg:mb-0 lg:mx-0 lg:w-1/2 lg:max-w-full lg:absolute xl:px-0" data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="2000">
          <img className="object-cover h-56 rounded shadow-lg lg:rounded-none lg:shadow-2xl md:h-96 lg:h-full" src={impactresistant} alt="Impact Resistant Gypsum Plasteboard" />
        </div>
      </div>

      {/* <div className="flex justify-center text-2xl mt-32 uppercase" data-aos="fade-up"
        data-aos-anchor-placement="top-center">
        <div className="w-full">
          <h1 className="text-4xl xs:text-xl sm:text-xl md:text-4xl font-bold bg-center text-center">Technical Specification</h1>
          <div className="flex justify-center">
            <table className="table-auto mb-8 mt-6 w-full max-w-2xl mx-5">
              <thead>
                <tr className="bg-gray-100 text-base">
                  <th className="border px-4 py-2">Thickness</th>
                  <th className="border px-4 py-2">Width</th>
                  <th className="border px-4 py-2">Length</th>
                  <th className="border px-4 py-2">Edge Type</th>
                </tr>
              </thead>
              <tbody className="text-base xs:text-xs sm:text-xs  md:text-base text-center">

                <tr className="bg-white">
                  <td className="border px-4 py-2">12.5 mm</td>
                  <td className="border px-4 py-2">1200 mm</td>
                  <td className="border px-4 py-2">1830 mm</td>
                  <td className="border px-4 py-2">T/E S/E</td>
                </tr>
                <tr className="bg-white">
                  <td className="border px-4 py-2">12.5 mm</td>
                  <td className="border px-4 py-2">1220 mm</td>
                  <td className="border px-4 py-2">2400 mm</td>
                  <td className="border px-4 py-2">T/E S/E</td>
                </tr>
                <tr className="bg-white">
                  <td className="border px-4 py-2">12.5 mm</td>
                  <td className="border px-4 py-2">1220 mm</td>
                  <td className="border px-4 py-2">2440 mm</td>
                  <td className="border px-4 py-2">T/E S/E</td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div> */}

      <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20" data-aos="fade-up" data-aos-anchor-placement="top-center">
        <h5 className="mb-8 text-4xl xs:text-3xl font-extrabold leading-none text-center md:text-left underline md:text-4xl">Application</h5>
        <div className="grid ">
          <ul className="space-y-3">
            <li className="flex items-start text-xl xs:text-base md:text-xl">
              <span className="mr-1">
                <svg className="w-5 h-5 mt-px text-deep-purple-accent-400" stroke="currentColor" viewBox="0 0 52 52">
                  <polygon strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" points="29 13 14 29 25 29 23 39 38 23 27 23" />
                </svg>
              </span>
              Ideal for high-traffic areas such as schools, hospitals, offices, and commercial buildings, providing durable wall and ceiling solutions.
            </li>
          </ul>
        </div>
      </div>

      <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20" data-aos="fade-up"
        data-aos-anchor-placement="top-center">
        <h5 className="mb-8 text-4xl xs:text-3xl font-extrabold leading-none text-center md:text-left underline  md:text-4xl">Classification</h5>
        <div className="grid ">
          <ul className="space-y-3">
            <li className="flex items-start text-xl xs:text-base md:text-xl">
              <span className="mr-1">
                <svg className="w-5 h-5 mt-px text-deep-purple-accent-400" stroke="currentColor" viewBox="0 0 52 52">
                  <polygon strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" points="29 13 14 29 25 29 23 39 38 23 27 23" />
                </svg>
              </span>
              Reinforced gypsum board designed for impact resistance, fire performance, and sound insulation.
            </li>
          </ul>
        </div>
      </div>

      <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20" data-aos="fade-up"
        data-aos-anchor-placement="top-center">
        <h5 className="mb-8 text-4xl xs:text-3xl font-extrabold leading-none text-center md:text-left underline  md:text-4xl">Thermal Conductivity</h5>
        <div className="grid ">
          <ul className="space-y-3">
            <li className="flex items-start text-xl xs:text-base md:text-xl">
              <span className="mr-1">
                <svg className="w-5 h-5 mt-px text-deep-purple-accent-400" stroke="currentColor" viewBox="0 0 52 52">
                  <polygon strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" points="29 13 14 29 25 29 23 39 38 23 27 23" />
                </svg>
              </span>
              0.17 – 0.25 W/m·K,
            </li>
          </ul>
        </div>
      </div>

      <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20" data-aos="fade-up"
        data-aos-anchor-placement="top-center">
        <h5 className="mb-8 text-4xl md:text-4xl font-extrabold leading-none md:pl-2 xs:text-3xl xs:text-center md:text-left underline">
          Key Features
        </h5>

        <div className="grid gap-3 row-gap-3  xs:text-base md:text-xl">
          <ul className="space-y-3">
            <li className="flex items-start">
              <span className="mr-1">
                <svg
                  className="w-5 h-5 mt-px text-deep-purple-accent-400"
                  stroke="currentColor"
                  viewBox="0 0 52 52"
                >
                  <polygon
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                    points="29 13 14 29 25 29 23 39 38 23 27 23"
                  />
                </svg>
              </span>
              High impact and dent resistance
            </li>
            <li className="flex items-start">
              <span className="mr-1">
                <svg
                  className="w-5 h-5 mt-px text-deep-purple-accent-400"
                  stroke="currentColor"
                  viewBox="0 0 52 52"
                >
                  <polygon
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                    points="29 13 14 29 25 29 23 39 38 23 27 23"
                  />
                </svg>
              </span>
              Superior strength and rigidity
            </li>


            <li className="flex items-start">
              <span className="mr-1">
                <svg
                  className="w-5 h-5 mt-px text-deep-purple-accent-400"
                  stroke="currentColor"
                  viewBox="0 0 52 52"
                >
                  <polygon
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                    points="29 13 14 29 25 29 23 39 38 23 27 23"
                  />
                </svg>
              </span>
              Excellent fire, moisture, and sound performance
            </li>


            <li className="flex items-start">
              <span className="mr-1">
                <svg
                  className="w-5 h-5 mt-px text-deep-purple-accent-400"
                  stroke="currentColor"
                  viewBox="0 0 52 52"
                >
                  <polygon
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                    points="29 13 14 29 25 29 23 39 38 23 27 23"
                  />
                </svg>
              </span>
              Smooth surface for easy finishing and painting
            </li>

            <li className="flex items-start">
              <span className="mr-1">
                <svg
                  className="w-5 h-5 mt-px text-deep-purple-accent-400"
                  stroke="currentColor"
                  viewBox="0 0 52 52"
                >
                  <polygon
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                    points="29 13 14 29 25 29 23 39 38 23 27 23"
                  />
                </svg>
              </span>
              Suitable for partitions, wall linings, and ceilings
            </li>


          </ul>
        </div>
      </div>

      <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20" data-aos="fade-up"
        data-aos-anchor-placement="top-center">
        <h5 className="mb-8 text-4xl xs:text-3xl font-extrabold leading-none text-center md:text-left underline  md:text-4xl">Key Benefits</h5>
        <div className="grid ">
          <ul className="space-y-3">
            <li className="flex items-start text-xl xs:text-base md:text-xl">
              <span className="mr-1">
                <svg className="w-5 h-5 mt-px text-deep-purple-accent-400" stroke="currentColor" viewBox="0 0 52 52">
                  <polygon strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" points="29 13 14 29 25 29 23 39 38 23 27 23" />
                </svg>
              </span>
              High Impact Resistance: Protects walls and ceilings from dents, scratches, and surface damage.
            </li>
            <li className="flex items-start text-xl xs:text-base md:text-xl">
              <span className="mr-1">
                <svg className="w-5 h-5 mt-px text-deep-purple-accent-400" stroke="currentColor" viewBox="0 0 52 52">
                  <polygon strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" points="29 13 14 29 25 29 23 39 38 23 27 23" />
                </svg>
              </span>
              Durable & Long-Lasting: Reinforced core ensures structural strength over time.
            </li>

            <li className="flex items-start text-xl xs:text-base md:text-xl">
              <span className="mr-1">
                <svg className="w-5 h-5 mt-px text-deep-purple-accent-400" stroke="currentColor" viewBox="0 0 52 52">
                  <polygon strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" points="29 13 14 29 25 29 23 39 38 23 27 23" />
                </svg>
              </span>
              Fire and Moisture Performance: Offers added safety and longevity in challenging environments.
            </li>

            <li className="flex items-start text-xl xs:text-base md:text-xl">
              <span className="mr-1">
                <svg className="w-5 h-5 mt-px text-deep-purple-accent-400" stroke="currentColor" viewBox="0 0 52 52">
                  <polygon strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" points="29 13 14 29 25 29 23 39 38 23 27 23" />
                </svg>
              </span>
              Sound Insulation: Helps reduce noise transmission for comfortable interiors.
            </li>

            <li className="flex items-start text-xl xs:text-base md:text-xl">
              <span className="mr-1">
                <svg className="w-5 h-5 mt-px text-deep-purple-accent-400" stroke="currentColor" viewBox="0 0 52 52">
                  <polygon strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" points="29 13 14 29 25 29 23 39 38 23 27 23" />
                </svg>
              </span>
             Easy to Finish: Smooth surface allows for painting, wallpapering, or other finishes.
            </li>

            <li className="flex items-start text-xl xs:text-base md:text-xl">
              <span className="mr-1">
                <svg className="w-5 h-5 mt-px text-deep-purple-accent-400" stroke="currentColor" viewBox="0 0 52 52">
                  <polygon strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" points="29 13 14 29 25 29 23 39 38 23 27 23" />
                </svg>
              </span>
              Versatile Application: Suitable for partitions, ceilings, and wall linings in high-traffic areas
            </li>

          </ul>
        </div>
      </div>



      <Footer></Footer>
    </>
  );
};

export default FireResistant;
